import React from 'react';
import { Pencil as Icon } from 'react-bootstrap-icons';
import { useController } from './provider';

export const EditButton = () => {
    const { canSave, isEditing, showEditor } = useController();
    return !canSave || isEditing ? null : (
        <div style={{ cursor: 'pointer' }} onClick={showEditor} ><Icon /></div>
    );
};
